import { createRouter, createWebHistory } from 'vue-router'
import i18n from '@/app/i18n'

import routes from '@/app/router/routes'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.afterEach((to) => {
  document.title =
    to.meta && to.meta.title
      ? i18n.global.t(to.meta.title)
      : 'EMCD Partner Space'
})

export default router
